// Port of api/fuel/app/classes/insights/game/calendar.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'calendar',
    priority: 3,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.has_plays) return {}

        var playsRaw = this._data.plays_raw

        // Default to sunday start (config not available offline)
        var sundayStart = true

        var plays = {}
        var total = 0

        // Group plays by date
        var dates = {}

        for (var i = 0; i < playsRaw.length; i++) {
            var play = playsRaw[i]
            var d = parseInt(play.play_date, 10) || 0

            if (d <= 0) continue

            if (!dates[d]) {
                dates[d] = { play_date: d, play_count: 0, play_index: [] }
            }

            dates[d].play_count += parseInt(play.play_count, 10) || 0
            dates[d].play_index.push(parseInt(play.play_id, 10))
        }

        // All-time mode: aggregate by week-of-year
        var dateKeys = Object.keys(dates)
        for (var di = 0; di < dateKeys.length; di++) {
            var item = dates[dateKeys[di]]
            var week = Util.weekofyear(item.play_date, sundayStart)
            var stamp = Util.date('Y', item.play_date) + '/' + week

            if (!plays[stamp]) {
                plays[stamp] = { count: 0, index: [] }
            }

            plays[stamp].count += item.play_count
            plays[stamp].index = item.play_index.concat(plays[stamp].index)

            total += item.play_count
        }

        // Find start from earliest play
        var start = 0
        var playKeys = Object.keys(plays)

        for (var pi = 0; pi < playKeys.length; pi++) {
            var parts = playKeys[pi].split('/')
            var time = Util.mktime(0, 0, 0, [1, 1, parseInt(parts[0], 10)])

            if (start === 0 || time < start) {
                start = time
            }
        }

        return {
            heatmap: {
                start: start,
                end: Util.time(),
                plays: plays,
                total: total
            }
        }

    }
})
